<template>
  <el-dialog :visible.sync="showPopup"
             :append-to-body="true"
             width="500px"
             title="修改密码">
    <div>
      <el-form label-width="0px">
        <el-form-item label="">
          <el-input :type="plaintext?'text':'password'"
                    v-model="formItem.new_password">
            <span class="label"
                  slot="prepend">
              <k-icon name="lock" /><span class="label-text">新密码</span>
            </span>
            <span slot="append"
                  class="attention"
                  @click="plaintext=!plaintext">
              <template v-if="plaintext">
                <k-icon name="attention" />
              </template>
              <template v-else>
                <k-icon name="attentionforbid" />
              </template>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input :type="plaintext?'text':'password'"
                    v-model="formItem.confirm_password">
            <span class="label"
                  slot="prepend">
              <k-icon name="auction"
                      size="15" /><span class="label-text">确认密码</span>
            </span>
            <span slot="append"
                  class="attention"
                  @click="plaintext=!plaintext">
              <template v-if="plaintext">
                <k-icon name="attention"
                        size="15" />
              </template>
              <template v-else>
                <k-icon name="attentionforbid"
                        size="15" />
              </template>
            </span>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="default"
                 @click="close">取消</el-button>
      <el-button type="primary"
                 @click="onSave">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      showPopup: false,
      formItem: {
        new_password: '',
        confirm_password: ''
      },
      plaintext: false
    }
  },
  methods: {
    show () {
      this.showPopup = true
    },
    close () {
      this.showPopup = false
    },
    onSave () {
      console.info(this.formItem)
      this.$requestApi('admin/update/pwd', this.formItem, 'POST').then(res => {
        if (res.code === 0) {
          this.showPopup = false
          this.$message.success('修改成功')
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  display: inline-block;
  width: 80px;
  .label-text {
    padding-left: 5px;
  }
}
.attention {
  cursor: pointer;
}
</style>
